import React from 'react';
import About from './AboutSection';
import Feature from './FeatureSection';
import Banner from './HomeThreeBanner';
import Service from './ServiceSection';
import CTA from '../../components/CTA';
import CTA1 from '../home/CtaSection';
import bgImg from '../../assets/img/cta/cta-bg-2.png';

const HomeThreeMain = () => {
  return (
    <main>
      <Banner />

      <Feature />

      <About />

      <Service />

      <CTA1 />
      
    </main>
  );
};

export default HomeThreeMain;
